import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ModulesListComponent } from './modules-list/modules-list.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: ModulesListComponent,
        data: {
          title: 'Modules'
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ModulesRoutingModule {
}
